import { render, staticRenderFns } from "./ztable.vue?vue&type=template&id=2cbdb3bc&scoped=true&"
import script from "./ztable.vue?vue&type=script&lang=js&"
export * from "./ztable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbdb3bc",
  null
  
)

export default component.exports